/**
 * The logged in user of the application
 */
export default class AppUser {
  /**
   * The full name of the user
   */
  fullName: string = ''

  /**
   * The roles of the user
   */
  roles: string[] = []
}
